(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./components", "./wrapper", "./dialog"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./components"), require("./wrapper"), require("./dialog"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.components, global.wrapper, global.dialog);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _components, _wrapper, _dialog) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Modal = _exports.Upload = _exports.TreeSelect = _exports.Cascader = _exports.Rate = _exports.InputNumber = _exports.TimePicker = _exports.DatePicker = _exports.Slider = _exports.Switch = _exports.AutoComplete = _exports.Radio = _exports.Checkbox = _exports.Select = _exports.Button = _exports.Input = _exports.Dialog = void 0;
  _components = _interopRequireDefault(_components);
  _wrapper = _interopRequireDefault(_wrapper);
  _dialog = _interopRequireDefault(_dialog);
  var wrapperedSummary = (0, _wrapper.default)(_components.default);
  var Dialog = (0, _dialog.default)({
    Modal: wrapperedSummary.Modal,
    Button: wrapperedSummary.Button
  });
  _exports.Dialog = Dialog;
  var Input = wrapperedSummary.Input,
      Button = wrapperedSummary.Button,
      Select = wrapperedSummary.Select,
      Checkbox = wrapperedSummary.Checkbox,
      Radio = wrapperedSummary.Radio,
      AutoComplete = wrapperedSummary.AutoComplete,
      Switch = wrapperedSummary.Switch,
      Slider = wrapperedSummary.Slider,
      DatePicker = wrapperedSummary.DatePicker,
      TimePicker = wrapperedSummary.TimePicker,
      InputNumber = wrapperedSummary.InputNumber,
      Rate = wrapperedSummary.Rate,
      Cascader = wrapperedSummary.Cascader,
      TreeSelect = wrapperedSummary.TreeSelect,
      Upload = wrapperedSummary.Upload,
      Modal = wrapperedSummary.Modal;
  _exports.Modal = Modal;
  _exports.Upload = Upload;
  _exports.TreeSelect = TreeSelect;
  _exports.Cascader = Cascader;
  _exports.Rate = Rate;
  _exports.InputNumber = InputNumber;
  _exports.TimePicker = TimePicker;
  _exports.DatePicker = DatePicker;
  _exports.Slider = Slider;
  _exports.Switch = Switch;
  _exports.AutoComplete = AutoComplete;
  _exports.Radio = Radio;
  _exports.Checkbox = Checkbox;
  _exports.Select = Select;
  _exports.Button = Button;
  _exports.Input = Input;
});